import AssemblySheetService from "../AssemblySheetService"
import AssemblySheetApplianceRepairEntity from "../Entity/AssemblySheetApplianceRepairEntity"

const
    PROCESSING_RECORD = "PROCESSING_RECORD",
    PROCESSING_RECORD_SUCCESS = "PROCESSING_RECORD_SUCCESS",
    PROCESSING_RECORD_ERROR = "PROCESSING_RECORD_ERROR"

const initialState = {
    isProcessing: false,
    record: null
}

export const state = {...initialState}

export const actions = {

    async createRepair({commit}, {assemblySheetId, applianceId, formData}) {
        try {
            commit(PROCESSING_RECORD)
            let response = await AssemblySheetService.createApplianceRepair(
                assemblySheetId,
                applianceId,
                formData
            )
            commit(PROCESSING_RECORD_SUCCESS, response.data)
            return state.record
        } catch (error) {
            commit(PROCESSING_RECORD_ERROR, error)
            return Promise.reject(error)
        }
    },

    async updateRepair({commit}, {assemblySheetId, applianceId, repairId, formData}) {
        try {
            commit(PROCESSING_RECORD)
            let response = await AssemblySheetService.updateApplianceRepair(
                assemblySheetId,
                applianceId,
                repairId,
                formData
            )
            commit(PROCESSING_RECORD_SUCCESS, response.data)
            return state.record
        } catch (error) {
            commit(PROCESSING_RECORD_ERROR, error)
            return Promise.reject(error)
        }
    },

    async deleteRepair({commit}, {assemblySheetId, applianceId, repairId}) {
        try {
            commit(PROCESSING_RECORD)
            let response = await AssemblySheetService.deleteApplianceRepair(
                assemblySheetId,
                applianceId,
                repairId,
            )
            commit(PROCESSING_RECORD_SUCCESS, response.data)
            return state.record
        } catch (error) {
            commit(PROCESSING_RECORD_ERROR, error)
            return Promise.reject(error)
        }
    }

}

export const mutations = {

    [PROCESSING_RECORD](state) {
        state.isProcessing = true
        state.error = null
        state.record = null
    },
    [PROCESSING_RECORD_SUCCESS](state, data) {
        state.isProcessing = false
        state.error = null
        state.record = AssemblySheetApplianceRepairEntity.from(data)
    },
    [PROCESSING_RECORD_ERROR](state, error) {
        state.isProcessing = false
        state.error = error
        state.record = null
    }

}

export const getters = {

    isProcessing(state) {
        return state.isProcessing
    },
    hasError(state) {
        return state.error !== null
    },
    error(state) {
        return state.error
    },
    hasRecord(state) {
        return state.record !== null
    },
    getRecord(state) {
        return state.record
    }

}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
